import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  MatCalendarCellClassFunction,
  MatDatepicker,
  MatDatepickerInputEvent
} from '@angular/material/datepicker';
import { format } from 'date-fns';
import { Moment } from 'moment';

import { MatDatePickerOptions } from '@amfam/shared/models';
import { Option } from '@amfam/ui-kit';

@Component({
  selector: 'amfam-select-payment-date',
  templateUrl: './select-payment-date.component.html',
  styleUrls: ['./select-payment-date.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class SelectPaymentDateComponent {
  @Input() paymentDateOptions: Option[];
  @Input() formGroup: UntypedFormGroup;
  @Input() disableRadioSelection: boolean;
  @Input() matDatePickerOptions: MatDatePickerOptions;
  @Input() hasPastDue: boolean;
  @Output() datePickerChangeEvent = new EventEmitter();
  @Output() dateRadioChangeEvent = new EventEmitter();
  unselectAll = false;
  todayDate: Date = new Date();

  constructor() {}

  dateClass: MatCalendarCellClassFunction<Moment> = (cellDate, view) => {
    // Only highligh dates inside the month view.
    if (view === 'month') {
      // Only highlight the desired date.
      return cellDate.date() === this.matDatePickerOptions.highlightDate.getDate()
        ? 'highlight-due-date'
        : '';
    }

    return '';
  };

  radioGroupChangeEvent(event: InputEvent) {
    this.unselectAll = false;
    this.dateRadioChangeEvent.emit(event);
  }

  optionsSelected(selectedDate: MatDatepickerInputEvent<Date>, picker: MatDatepicker<Moment>) {
    this.unselectAll = false;
    this.formGroup.controls['paymentDatePicker'].setValue(null);
    this.dateRadioChangeEvent.emit(selectedDate);
    picker.select(null);
  }

  optionsSelectedDatePicker(selectedDate: MatDatepickerInputEvent<Date>) {
    if (selectedDate.value) {
      this.unselectAll = true;
      this.formGroup.controls['paymentDate'].setValue('');
      const formattedDate = format(selectedDate.value, 'MMM DD, YYYY');
      this.formGroup.controls['paymentDatePicker'].setValue(formattedDate);
      this.datePickerChangeEvent.emit(formattedDate);
    }
  }
}
